import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CalendarioRoutingModule } from './calendario-routing.module';
import { CalendarioImportarComponent } from './calendario-importar/calendario-importar.component';
import { GLMMaterialDesignModule } from 'src/app/_components/material-design/material-design.module';
import { ReactiveFormsModule } from '@angular/forms';
import { CalendarioImportarCargarArchivoComponent } from './calendario-importar-cargar-archivo/calendario-importar-cargar-archivo.component';
import { CalendarioImportarEmparejarComponent } from './calendario-importar-emparejar/calendario-importar-emparejar.component';
import { CalendarioImportarVerificarComponent } from './calendario-importar-verificar/calendario-importar-verificar.component';
import { HorarioHomeComponent } from './horario-home/horario-home.component';
import { HorarioMateriasListaComponent } from './horario-materias-lista/horario-materias-lista.component';
import { HorarioActividadesImportarComponent } from './horario-actividades-importar/horario-actividades-importar.component';


@NgModule({
  declarations: [
    CalendarioImportarComponent, 
    CalendarioImportarCargarArchivoComponent, 
    CalendarioImportarEmparejarComponent, 
    CalendarioImportarVerificarComponent, 
    HorarioHomeComponent, 
    HorarioMateriasListaComponent, 
    HorarioActividadesImportarComponent
  ],
  imports: [
    CommonModule,
    GLMMaterialDesignModule,
    ReactiveFormsModule,

    CalendarioRoutingModule,
  ],
})
export class CalendarioModule { }
